import {
  QueryNewNotificationsRequest,
  ViewAllNotificationsRequest,
  ViewNewNotificationsRequest
} from './notification.types';

import { API_HOST, HttpGetOptions, getHttpGetOptions } from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/notification`;

export const getViewAllNotificationsRequest = (data: ViewAllNotificationsRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/${data.systemUserExternalReference}`,
  getHttpGetOptions()
];

export const getQueryNewNotificationsRequest = (data: QueryNewNotificationsRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/${data.systemUserExternalReference}/${data.lastNotificationUUID}/new`,
  getHttpGetOptions()
];

export const getViewNewNotificationsRequest = (data: ViewNewNotificationsRequest): [string, HttpGetOptions] => [
  `${getEndpoint()}/${data.systemUserExternalReference}/${data.lastNotificationUUID}/new/retrieve`,
  getHttpGetOptions()
];
